import { render, staticRenderFns } from "./UserBecome.vue?vue&type=template&id=cb3d5bfc&"
import script from "./UserBecome.vue?vue&type=script&lang=js&"
export * from "./UserBecome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3d5bfc')) {
      api.createRecord('cb3d5bfc', component.options)
    } else {
      api.reload('cb3d5bfc', component.options)
    }
    module.hot.accept("./UserBecome.vue?vue&type=template&id=cb3d5bfc&", function () {
      api.rerender('cb3d5bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/authentication/views/UserBecome.vue"
export default component.exports